import { configureStore } from "@reduxjs/toolkit";
import mapSlice from "./mapStore";
import mainSlice from "./mainStore";
import passengerSignalRSlice from "./signalRStore";
import userStore from "pages/common/store/userStore";
import RequestSlice from "pages/passenger/request/store/requestStore";
import RequestMapSlice from "pages/passenger/request/store/mapStore";

export const store = configureStore({
  reducer: {
    mainStore: mainSlice.reducer,
    mapStore: mapSlice.reducer,
    userStore: userStore.reducer,
    signalRStore: passengerSignalRSlice.reducer,
    requestStore: RequestSlice.reducer,
    requestMapSlice: RequestMapSlice.reducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
